import styled from "styled-components";

const ButtonSelectSlide = styled.button`
  width: 40px;
  height: 6px;
  border-radius: 5px;
  border: none;
  background-color: ${ props => props.selected };
  cursor: pointer;
`;

const ButtonRuleSlide = ({ selected, onBulletClick, index, currentBullet }) => {
  return (
    <ButtonSelectSlide selected={selected} onClick={() => {
        if (index !== currentBullet) {
          onBulletClick(index);
        }
      }}></ButtonSelectSlide>
  );
};

export default ButtonRuleSlide;
